import { skipToken } from '@reduxjs/toolkit/query';

import {
  useGetAssignmentsQuery,
  useSetStartWorkToAssignmentMutation,
  useSetEndWorkToAssignmentMutation,
} from '@/pages/Fleet/Assignment/services/assignments.service.ts';
import { AssignmentType } from '@/pages/Fleet/Assignment/models/Assignment';

export interface AssignmentsFilter {
  dateFrom?: Date | null;
  dateTo?: Date | null;
  driverId?: string;
  businessId?: string;
  vehicleId?: string;
  status?: string[];
  vehicleTypeId?: string;
  serviceTypeId?: string;
}

interface UseAssignmentProps {
  type: AssignmentType;
  filters?: AssignmentsFilter;
  page: number;
  pageSize: number;
  skip?: boolean;
}

const useAssignments = ({
  type,
  filters,
  page,
  pageSize,
  skip,
}: UseAssignmentProps) => {
  const { data, isLoading, error } = useGetAssignmentsQuery(
    skip
      ? skipToken
      : {
          type,
          filters: {
            driverId: filters?.driverId,
            businessId: filters?.businessId,
            vehicleId: filters?.vehicleId,
            vehicleTypeId: filters?.vehicleTypeId,
            serviceTypeId: filters?.serviceTypeId,
            dateFrom: filters?.dateFrom?.toISOString(),
            dateTo: filters?.dateTo?.toISOString(),
            status: filters?.status,
          },
          paginated: { page, pageSize },
        }
  );

  const [setStartWork] = useSetStartWorkToAssignmentMutation();
  const [setEndWork] = useSetEndWorkToAssignmentMutation();

  const filteredAssignments =
    data?.items?.filter((assignment) => assignment.status !== 'DISCARDED') ||
    [];

  return {
    isLoading,
    error,
    assignments: filteredAssignments,
    totalItems: data?.count || 0,
    totalPages: Math.ceil((data?.count || 0) / pageSize),
    setStartWork: async (assignmentId: string, startWork?: string) => {
      return setStartWork({ assignmentId, startWork });
    },
    setEndWork: async (assignmentId: string, endWork?: string) => {
      return setEndWork({ assignmentId, endWork });
    },
  };
};

export default useAssignments;
